import { z } from 'zod';
import { workerEmploymentTypeSchema } from '../zod-schemas/schema';

export const claimFlexWorkerSchema = z.object({
  firstName: z.string(),
  lastName: z.string(),
  infix: z.string().nullable().optional(),
  workerId: z.string(),
  email: z.string().optional(),
  phone: z.string().nullable().optional(),
  flexPools: z.array(z.object({ flexPoolId: z.string() })).optional(),
  imageUrl: z.string().optional(),
  experienceInMonths: z.number().optional(),
  distanceInKm: z.number().optional(),
  employmentType: workerEmploymentTypeSchema,
});
